// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2RdZZ","content":"GlobalSearch_content__3e4XG"};